import { useEffect } from "react";
import { toast } from "sonner";
import { useWSEvent } from "../context/WebSocketContext";

/**
 * Global toasts for background_job WebSocket events.
 */
export function useBackgroundJobNotifications(handlers = {}) {
  useWSEvent("background_job", (event) => {
    const action = String(event?.action || "").toLowerCase();
    const title = event?.title || "Background task";
    const message = event?.message || "";
    const kind = event?.kind || "";

    if (action === "completed") {
      toast.success(title, { description: message || "Task completed" });
      handlers[kind]?.(event);
      handlers["*"]?.(event);
    } else if (action === "failed") {
      toast.error(title, { description: message || event?.error || "Task failed" });
      handlers[kind]?.(event);
      handlers["*"]?.(event);
    }
  });
}

/** Invoke callback when a specific job_id completes or fails. */
export function useBackgroundJobResult(jobId, onDone) {
  const stableId = jobId ? String(jobId) : "";

  useEffect(() => {
    if (!stableId || !onDone) return undefined;
    return () => {};
  }, [stableId, onDone]);

  useWSEvent("background_job", (event) => {
    if (!stableId || String(event?.job_id || "") !== stableId) return;
    if (event?.action === "completed" || event?.action === "failed") {
      onDone?.(event);
    }
  });
}
